import { DateInput } from "./DateInput";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { successToast } from "./SuccessCheck";
import { api, formatApiError } from "../lib/api";

import { tr, lbl } from "../lib/i18n";
const METHODS = ["Cash", "Bank Transfer", "Card", "Cheque"];
const field = "w-full h-10 rounded-lg border border-[hsl(var(--border))] bg-white px-3 text-sm";

/** Record a sale payment (append-only ledger entry). */
export const RecordPaymentModal = ({ onClose, onSaved }) => {
  const [sales, setSales] = useState([]);
  const [form, setForm] = useState({ sale_id: "", amount: "", method: "Cash", date: new Date().toISOString().slice(0, 10), reference: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    Promise.all(["Confirmed", "Partially Paid"].map((status) => api.get("/sales", { params: { status, limit: 200 } })))
      .then((rs) => setSales(rs.flatMap((r) => r.data.items || [])))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  const save = async () => {
    if (!form.sale_id) { toast.error(tr("x.choose_a_sale")); return; }
    if (!(Number(form.amount) > 0)) { toast.error(tr("x.amount_must_be_greater_than_zero")); return; }
    setBusy(true);
    try {
      await api.post(`/sales/${form.sale_id}/payment`, { ...form, amount: Number(form.amount) });
      successToast(tr("x.payment_recorded"));
      onSaved();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return createPortal(
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div className="panel p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()} data-testid="record-payment-modal">
        <div className="eyebrow mb-3">{tr("x.record_payment")}</div>
        <div className="space-y-3">
          <select className={field} value={form.sale_id} onChange={set("sale_id")} data-testid="pay-sale">
            <option value="">{tr("x.sale_invoice")}</option>
            {sales.map((s) => <option key={s.id} value={s.id}>{s.reference} · {s.buyer_name || ""} · {s.vehicle_label || ""}</option>)}
          </select>
          <input className={field} type="number" min="0" step="0.001" placeholder={tr("x.amount")} value={form.amount} onChange={set("amount")} data-testid="pay-amount" />
          <select className={field} value={form.method} onChange={set("method")} data-testid="pay-method">
            {METHODS.map((m) => <option key={m} value={m}>{lbl(m)}</option>)}
          </select>
          <DateInput className={field} type="date" value={form.date} onChange={set("date")} data-testid="pay-date" />
          <input className={field} placeholder={tr("x.reference_receipt_transfer_no")} value={form.reference} onChange={set("reference")} data-testid="pay-reference" />
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="btn-secondary" data-testid="pay-cancel">{tr("x.cancel")}</button>
          <button onClick={save} disabled={busy} className="btn-primary" data-testid="pay-submit">{busy ? tr("x.saving") : tr("x.record_payment")}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};
